import RcToMp4 from './RcToMp4';
import './App.css';

const AppRcToMp4 = "RcToMp4";
const urlParameter = paramName => ( new URLSearchParams( window.location.search )).get( paramName );

function App() {
  const privacyPolicy = urlParameter("privacypolicy");

  if (urlParameter("app") === AppRcToMp4) {
    var version = urlParameter("ver");
    return RcToMp4(version, privacyPolicy);
  }

  return (
    <div className="App">
      <p>アプリケーションの指定が不明です。</p>
      <a href='https://www.ryujincomputing.co.jp/'>龍神コンピューティングのトップページへ</a>
    </div>  
  );
}

export default App;
